import React from 'react';
import { Box, Typography } from '@mui/material';

// Brand mark: paper plane with a trail — the "send" mark (option D).
// Same geometry as public/logo/socialflow-icon.svg so the in-app mark and
// the exported developer-app icon never drift apart.
export const LogoMark = ({ size = 28 }) => (
  <Box
    component="svg"
    viewBox="0 0 100 100"
    sx={{ width: size, height: size, flexShrink: 0, display: 'block' }}
  >
    <rect width="100" height="100" rx="24" fill="#FFFFFF" />
    <g transform="translate(15 15) scale(0.7)">
      <path d="M90 10 L8 44 L38 56 Z" fill="#1D5BFF" />
      <path d="M90 10 L38 56 L50 90 Z" fill="#0B2C8A" />
      <circle cx="28" cy="66" r="4.5" fill="#1D5BFF" />
      <circle cx="18" cy="76" r="3.6" fill="#1D5BFF" />
      <circle cx="9" cy="86" r="2.8" fill="#1D5BFF" />
    </g>
  </Box>
);

const Logo = ({ size = 28, collapsed = false, textColor = 'inherit' }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.1, overflow: 'hidden' }}>
    <LogoMark size={size} />
    {!collapsed && (
      <Box sx={{ minWidth: 0, lineHeight: 1 }}>
        <Typography
          noWrap
          sx={{ fontFamily: "'Unbounded', sans-serif", fontWeight: 700, fontSize: '0.95rem', letterSpacing: '-0.02em', color: textColor }}
        >
          Mom N Kidz
        </Typography>
        <Typography
          noWrap
          sx={{ fontFamily: "'Unbounded', sans-serif", fontWeight: 600, fontSize: '0.55rem', letterSpacing: '0.08em', color: '#1D5BFF', mt: 0.4 }}
        >
          SocialFlow
        </Typography>
      </Box>
    )}
  </Box>
);

export default Logo;
